<template>
  <div class="text-add">
    <input ref="input" class="w-full" type="text" v-model="computedValue" />
    <a class="icon-container" @click="addText">
      <i class="bdg-icon plus fa-fw text-lg text-red" />
    </a>
  </div>
</template>

<script>
export default {
  name: "TextAdd",
  props: {
    value: String
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  mounted() {
    // Set keyup listening
    document.addEventListener("keyup", this.onKeyUp);
  },
  methods: {
    onKeyUp(event) {
      if (
        this.$el === document.activeElement ||
        this.$refs.input === document.activeElement
      ) {
        if (event.code === "Enter") {
          this.addText();
        }
      }
    },
    addText() {
      if (this.computedValue) {
        this.$emit("added");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.text-add {
  @apply relative;

  input[type="text"] {
    @apply pr-10;
  }

  .icon-container {
    top: 50%;
    right: 0;

    transform: translateY(-50%);

    @apply absolute px-4;

    i {
      @apply align-middle;
    }
  }
}
</style>
